import React, { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import { UserContext } from "./UserContext";
import NpdbLogo from "./images/NPDBlogo.png";
import "./Nav.css";
import "./index.css";

const Nav = () => {
  const { isAuthenticated, logout } = useContext(UserContext);
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    logout();
    window.location.href = "/";
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar custom-nav background-image">
      <div className="container-custom">
        {/* Logo */}
        <div className="navbar-brand">
          <NavLink to="/" onClick={closeMenu}>
            <img src={NpdbLogo} className="logo-img" alt="logo" />
          </NavLink>
        </div>

        {/* Hamburger Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation"
        >
          <span className={`hamburger-icon ${isOpen ? "open" : ""}`}>
            <div></div> {/* middle bar */}
          </span>
        </button>

        {/* Right-side content */}
        <div className={`navbar-collapse ${isOpen ? "show" : ""}`}>
          <div className="nav-right-content">
            <ul className="navbar-nav main-links">
              <li className="nav-item"><NavLink to="/" className="nav-link" onClick={closeMenu}>Home</NavLink></li>
              <li className="nav-item"><NavLink to={isAuthenticated ? "/wishlist" : "/login"} className="nav-link" onClick={closeMenu}>Wishlist</NavLink></li>
              <li className="nav-item"><NavLink to={isAuthenticated ? "/visited" : "/login"} className="nav-link" onClick={closeMenu}>Visited</NavLink></li>
              <li className="nav-item"><NavLink to={isAuthenticated ? "/reviews/mine" : "/login"} className="nav-link" onClick={closeMenu}>My Profile</NavLink></li>
              <li className="nav-item"><NavLink to="/visitors" className="nav-link" onClick={closeMenu}>Visitors</NavLink></li>
            </ul>

            <ul className="navbar-nav auth-links">
              {!isAuthenticated ? (
                <>
                  <li className="nav-item"><NavLink to="/signup" className="btn btn-primary custom-button" onClick={closeMenu}>Register</NavLink></li>
                  <li className="nav-item"><NavLink to="/login" className="btn btn-outline-primary custom-button" onClick={closeMenu}>Login</NavLink></li>
                </>
              ) : (
                <li className="nav-item">
                  <button className="btn btn-primary custom-button" onClick={() => { handleLogout(); closeMenu(); }}>Log Out</button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
